import { render, staticRenderFns } from "./custom-type6.vue?vue&type=template&id=17b6cd3f&scoped=true"
import script from "./custom-type6.vue?vue&type=script&lang=js"
export * from "./custom-type6.vue?vue&type=script&lang=js"
import style0 from "./custom-type6.vue?vue&type=style&index=0&id=17b6cd3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b6cd3f",
  null
  
)

export default component.exports